import { render } from "./AppCalendar.vue?vue&type=template&id=74d7755d"
import script from "./AppCalendar.vue?vue&type=script&lang=js"
export * from "./AppCalendar.vue?vue&type=script&lang=js"

import "./AppCalendar.vue?vue&type=style&index=0&id=74d7755d&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__